<template>
  <div class="battery">

    <div class="battery__value">{{ batteryData.value }}%</div>
<!--    <div class="battery__value">{{ 0 }}%</div>-->
    <div class="battery__progress progress">
      <battery-icon class="progress__icon"></battery-icon>
      <el-progress :percentage="batteryData.value" :color="batteryData.color" :stroke-width="8" :show-text="false"/>
    </div>

  </div>
</template>

<script>
import BatteryIcon from "@/components/icons/Battery.vue"

export default {
  name: "BatteryCharging",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    batteryData: {}
  },
  data() {
    return {}
  },
  components: {
    BatteryIcon
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.battery {
  //min-width: 63px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &__value {
    width: 100%;
    padding-right: 10px;

    text-align: right;
    font-size: 15px;
    line-height: 16px;
    color: #111;
  }
}

.progress {
  position: relative;
  z-index: 2;
  width: 36px;
  margin-right: 6px;

  &__icon {
    position: absolute;
    z-index: 3;
    top: -3px;
    left: -3px;
  }
}
</style>
